import React from 'react';
import Container from '../components/Container';
import Literal from '../literals/Literal';
import Head from '../components/Head';
import QRCode from "react-qr-code";

const DownloadEarlyBird = () => {
  return (
    <Container>
      {/* DESKTOP */}
      <Head paragraphsClassName="hidden md:block" paragraphs={[
        Literal("EB_DOWNLOAD_TITLE")
      ]} />
      
      {/* MOBILE */}
      <div className="flex flex-col items-center justify-between md:hidden mt-12">
        <div className="text-center">
          <h2 className="text-white text-2xl font-americaBold mb-4">{Literal("EB_DOWNLOAD_TITLE")}</h2>
          <p className="text-white text-md font-americaLight mb-4">{Literal("EB_CLICK_TO_SEE")}</p>
          <a
            href="https://acst.app/marketplaceEvent/667d22e824bebf0009b6b5a4"
            rel="noreferrer"
            target="_blank"
            className="w-full py-4 rounded-xl bg-lime mt-4 mb-8 block text-center"
          >
            <span className="text-base text-black font-americaBold">{Literal("EB_CLICK")}</span>
          </a>
        </div>
      </div>

      <p className="text-white text-base font-americaLight text-center mb-8 hidden md:block">{Literal("EB_DOWNLOAD_TEXT")}</p>
      <p className="text-white text-base font-americaLight text-center mb-8 md:hidden">{Literal("EB_DOWNLOAD_TEXT")}</p>

      {/* QR CODE */}
      <div className="mt-12">
        <div className="p-6 bg-white rounded-5xl">
          <QRCode value="https://acst.app/marketplaceEvent/667d22e824bebf0009b6b5a4" />
        </div>
      </div>

      {/* HELP SECTION */}
      <div className="flex flex-col items-center mt-12">
        <div className="text-center mb-6">
          <h4 className="text-white font-americaMedium text-lg mb-2">{Literal("DICE_DOUBTS")}</h4>
          <p className="text-white font-americaLight text-base">{Literal("DICE_HELP")}</p>
        </div>
        <a
          href="https://www.accessticket.app/intercom_v2.html"
          rel="noreferrer"
          target="_blank"
          className="w-full py-4 rounded-xl bg-lime block text-center"
        >
          <span className="text-base text-black font-americaBold">{Literal("DICE_CONTACT")}</span>
        </a>
      </div>
    </Container>
  );
};

export default DownloadEarlyBird;
